import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDBallStatistics implements ICommand
{

	public BallNumber : number = 0;
	public Occurence : number = 0;
	public LastOpenRound : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.BallNumber = ba.readUint8();
		this.Occurence = ba.readUint32();
		this.LastOpenRound = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.BallNumber);
		ba.writeUint32(this.Occurence);
		ba.writeUint32(this.LastOpenRound);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDBallStatistics();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'BallNumber(B)='+this.BallNumber+' ';
		str += 'Occurence(D)='+this.Occurence+' ';
		str += 'LastOpenRound(D)='+this.LastOpenRound+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'BallStatistics';
	}

}
